import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from '../lib/icons';
const RECENT_SALES = [{
  name: 'Romina S.',
  location: 'Córdoba'
}, {
  name: 'Gabriela M.',
  location: 'Rosario'
}, {
  name: 'Soledad P.',
  location: 'Buenos Aires'
}, {
  name: 'Mariana L.',
  location: 'Mendoza'
}, {
  name: 'Florencia R.',
  location: 'La Plata'
}, {
  name: 'Valentina T.',
  location: 'Tucumán'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const initialTimeout = setTimeout(() => setIsVisible(true), 4000);
    const cycleInterval = setInterval(() => {
      setIsAnimatingOut(true);
      setTimeout(() => {
        setIsVisible(false);
        setIsAnimatingOut(false);
        setTimeout(() => {
          setCurrentIndex(prev => (prev + 1) % RECENT_SALES.length);
          setIsVisible(true);
        }, 200);
      }, 300);
    }, 7000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, []);
  const handleDismiss = () => {
    setIsAnimatingOut(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsAnimatingOut(false);
    }, 300);
  };
  const currentSale = RECENT_SALES[currentIndex];
  if (!isVisible && !isAnimatingOut) return null;
  return <div className={`fixed bottom-20 md:bottom-4 left-4 z-50 max-w-[216px] md:max-w-[270px] ${isAnimatingOut ? 'animate-popup-out' : 'animate-popup-in'}`} data-id="element-310">
      <div className="bg-white rounded-lg p-3.5 shadow-2xl border border-gray-200 relative group" data-id="element-311">
        <button onClick={handleDismiss} className="absolute top-2 right-2 text-gray-300 hover:text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-312">
          <XIcon size={14} data-id="element-313" />
        </button>

        <div className="flex items-start gap-2.5" data-id="element-314">
          <div className="bg-green-100 p-1.5 rounded-full mt-0.5" data-id="element-315">
            <CheckCircle2Icon className="w-4 h-4 text-green-600" data-id="element-316" />
          </div>
          <div data-id="element-317">
            <p className="text-[0.78rem] text-gray-800 font-medium leading-tight" data-id="element-318">
              <span className="font-bold text-gray-900" data-id="element-319">
                {currentSale.name}
              </span>{' '}
              de {currentSale.location}
            </p>
            <p className="text-[0.7rem] text-gray-500 mt-1" data-id="element-320">
              acaba de adquirir el{' '}
              <span className="text-green-700 font-semibold" data-id="element-321">
                Curso Integral de Reiki
              </span>
            </p>
            <div className="flex items-center gap-1 mt-1.5" data-id="element-322">
              <span className="text-[9px] text-gray-400 uppercase tracking-wider font-semibold" data-id="element-323">
                Verificado por Mercado Pago
              </span>
              <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse" data-id="element-324"></div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}